<div>
    <mat-icon class="float-right color-text cursor-pointer-outline" (keyup.enter)="closeDialog()" (click)="closeDialog()" tabindex="0">close</mat-icon>
    <div class="status-popup-container display-flex-column flex-centered-container">
        <img class="status-img" src="/assets/images/tick.svg">
        <h2 class="color-text text-center font-inter-semibold" [innerHTML]="changePasswordText">
        </h2>
    </div>
</div>

